import useWindowDimensions from '@hooks/useWindowDimensions';
import React from 'react';
import styles from './index.module.scss';

const FLOURISH_HOST = 'wellbeing.flourish.co.uk';
const CLICK_LEARNING_DASHBOARD = 'https://app.click-learning.co.uk/dashboard';

export const FlourishClickLearningBanner: React.FC = () => {
  const { isDesktop } = useWindowDimensions();
  const isFlourishHost =
    typeof window !== 'undefined' && window.location.hostname === FLOURISH_HOST;

  if (!isFlourishHost || isDesktop) {
    return null;
  }

  return (
    <>
      <a href={CLICK_LEARNING_DASHBOARD} className={styles.banner}>
        Return to the Click Learning site
      </a>
      <div className={styles.spacer} aria-hidden="true" />
    </>
  );
};
